import type {SubscriptionProductIds, SubscriptionTierName} from '@/types/subscriptions';
import {
  SubscriptionType,
  toBundlesTierName,
  toMyAnalyticsTierName,
  toMyContractsTierName,
  toMyOrdersTierName,
  toMyScanAndPrintTierName,
} from '@/types/subscriptions';
import logToMonitor from '@/utils/logging';
import {getSubscriptionType} from '@/utils/subscriptions';

export const getSubscriptionTierName = (productId: SubscriptionProductIds): SubscriptionTierName | undefined => {
  const subscriptionType = getSubscriptionType(productId);

  switch (subscriptionType) {
    case SubscriptionType.MyAnalytics:
      return toMyAnalyticsTierName(productId);
    case SubscriptionType.MyContracts:
      return toMyContractsTierName(productId);
    case SubscriptionType.MyOrders:
      return toMyOrdersTierName(productId);
    case SubscriptionType.MyScanAndPrint:
      return toMyScanAndPrintTierName(productId);
    case SubscriptionType.Bundles:
      return toBundlesTierName(productId);

    default: {
      logToMonitor(Error('Unknown subscription type'), subscriptionType);
    }
  }
};
